<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Processos</h1>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovo" />

    <SGPTabelaComponent
      v-if="listaDeProcessos.length"
      :colunas="colunas"
      :dados="listaDeProcessos"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
      :filtroText="true"
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="lg"
      titulo="Processo"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioProcessoComponent
        :tipoFormulario="tipoFormulario"
        :processo="processo"
      />
    </SGPModalComponent> 
    
    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />
    
    <SGPLoadingComponent v-if="loadingProcessos"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioProcessoComponent from '../components/FormularioCtrlProcessoComponent.vue'
import moduleReload from '@/common/mixins/module-reload'

export default {
  components: { FormularioProcessoComponent },
  mixins: [moduleReload],
  name: 'ProcessoPage',

  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      processosSelecionados: [],
      abrirModal: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      processo: {}
    }
  },
  created () {
    this.listarProcessos();
  },
  computed: {
    ...mapGetters('ctrlProcessos', ['listaDeProcessos','loadingProcessos']),

    colunas () {
      return [
        {
          key: 'selecionar',
          label: '',
          sortable: false
        }, 
        {
          key: 'processo',
          label: 'Nome',
          sortable: false
        },
        {
          key: 'workflow.workflow',
          label: 'Workflow',
          sortable: false
        },
        {
          key: 'hierarquia.hierarquia',
          label: 'Processo Hierarquia',
          sortable: false
        },
        {
          key: 'hierarquia_pai.hierarquia',
          label: 'Hierarquia Pai',
          sortable: false
        },
        {
          key: 'hierarquia_filho.hierarquia',
          label: 'Hierarquia Filho',
          sortable: false
        },
        {
          key: 'tipo_aging.tipo',
          label: 'Tipo de Aging',
          sortable: false
        },
        {
          key: 'aging',
          label: 'Aging',
          sortable: false
        },
        {
          key: 'ordem',
          label: 'Ordem',
          sortable: false
        },
      ]
    }
  },

  methods: {
    ...mapActions('ctrlProcessos', 
    [
      'listarProcessos',
      'listarMacroProcessos',
      'excluirProcessos',
    ]),
    // ...mapActions('tiposHierarquias', 
    // [
    //   'listarTiposHierarquias'
    // ]),
    gerenciadorDeSelecionados (selecionados) {
      this.processosSelecionados = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.processo = this.processosSelecionados[0];
      this.listarMacroProcessos(this.processo);
      // this.listarTiposHierarquias();
      this.abrirModal = true;
    },

    deletarSelecionado () {
      this.deletarDados = true;
    },

    cancelarDelecao () {
      this.deletarDados = false;
    },

    confirmarDelecao () {
      this.excluirProcessos(this.processosSelecionados);
      this.deletarDados = false;
    },

    adicionarNovo () {
      this.processo = {};
      this.tipoFormulario = 'salvar';
      this.listarMacroProcessos();
      // this.listarTiposHierarquias();
      this.abrirModal = true;
    },

    fecharModal () {
      this.abrirModal = false;
    },

    reloadData () {
      this.listarProcessos();
    }

  }
}
</script>
